import { useState } from 'react';
import type { SingleGameFragment } from '~/client/components/Game/graphql/SingleGameFragment.generated';
import useInitialInGameCurrency from './useInitialInGameCurrency';

const useInGameCurrencyProps = (game?: SingleGameFragment) => {
  const inGameCurrencyList =
    game?.menuItem?.[0]?.inGameCurrencies?.split(',') ?? [];
  const initialInGameCurrency = useInitialInGameCurrency(inGameCurrencyList);
  const [inGameCurrency, setInGameCurrency] = useState<Maybe<string | null>>(
    initialInGameCurrency,
  );
  return {
    inGameCurrency:
      inGameCurrency === undefined ? initialInGameCurrency : inGameCurrency,
    setInGameCurrency,
    inGameCurrencyList,
  };
};

export default useInGameCurrencyProps;
